/**
 *
 * SplashScreen
 *
 */

import React, { memo, FunctionComponent, useState, useEffect } from 'react';
import { StyledSplashScreen } from './styledComponents';

interface IProps {}

const SplashScreen: FunctionComponent<IProps> = () => {
  const [longLoadingText, setlongLoadingText] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setlongLoadingText(true);
    }, 2000);
  }, [])
  return (
    <StyledSplashScreen>
      <div className="spinner-border mr-10" role="status"></div>
      {longLoadingText && (
        <span className="txt txt-secondary fs-11">Please be patient... Loading latest data...</span>
      )}
    </StyledSplashScreen>
  );
}

export default memo(SplashScreen);
